var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0,15.059 C0,7.96 0,4.41 2.205,2.205 C4.411,0 7.96,0 15.06,0 L16.942,0 C24.04,0 27.59,0 29.795,2.205 C32,4.411 32,7.96 32,15.06 L32,16.942 C32,24.041 32,27.59 29.795,29.796 C27.589,32 24.04,32 16.94,32 L15.06,32 C7.96,32 4.41,32 2.205,29.795 C0,27.589 0,24.04 0,16.94 L0,15.06 L0,15.059 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3CA35B",
    d: "M10,18.4706875 C10,14.4775 10,12.480625 11.2403125,11.2403125 C12.4811875,10 14.4775,10 18.47125,10 L19.529875,10 C23.5225,10 25.519375,10 26.7596875,11.2403125 C28,12.4811875 28,14.4775 28,18.47125 L28,19.529875 C28,23.5230625 28,25.519375 26.7596875,26.76025 C25.5188125,28 23.5225,28 19.52875,28 L18.47125,28 C14.4775,28 12.480625,28 11.2403125,26.7596875 C10,25.5188125 10,23.5225 10,19.52875 L10,18.47125 L10,18.4706875 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.65075c5f3bfb65e935720fcf03e7548b.svg";
export { ForwardRef as ReactComponent };